export const TRADEBUZA_URL = `${(process.env.ONE_FUEL_API_URL) || "https://referrals.tradebuza.com/api"}`;
export const TRADEBUZA_BLOG_URL = `https://blog-be.tradebuza.com/api`;
export const AGRO_BASE_URL = `${(process.env.REACT_APP_AGRO_BASE_URL) || "https://dev-agro-service.tradebuza.com/api/v3"}`;